module.exports = __webpack_public_path__ + "img/domplan_logo.06196250.jpg";